import { InjectionToken } from '@angular/core';

export const PAYPAL_CLIENT_ID = new InjectionToken<string>('PAYPAL_CLIENT_ID');
